import { useExperimentFlag } from './useExperimentFlag';

export const useProductsPreviewEnabled = () =>
    Number(useExperimentFlag('products_preview_enabled')) === 1;
